import script from "./ClassificationDropdowns.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationDropdowns.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationDropdowns.vue?vue&type=style&index=0&id=31bf1314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31bf1314"]])

export default __exports__